import { FC, useEffect, useState } from 'react';
import { observer, useNavigate, useParams } from '~/modules';
import { Routes } from '~/routes';
import { ACCOUNT_STATUS, QR_CODE_STATUS, useStores } from '~/utils';
import CreditSimulationIntro from './CreditSimulationIntro';

const CreditSimulationIntroContainer: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { creditProducts, user } = useStores();
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');

  const initialize = async () => {
    try {
      setLoading(true);
      const { tokenStatus, accountStatus } = await user.authenticate(
        id as string,
      );
      await creditProducts.getProducts();
      if (tokenStatus === QR_CODE_STATUS.WAITING_WITHDRAW) {
        navigate(Routes.CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION);
        return;
      }
      if (accountStatus === ACCOUNT_STATUS.WAITING_DOCUMENT) {
        navigate(Routes.ONBOARDING_INTRO);
        return;
      }
      await creditProducts.getProductLoanDetails();
      const { account } = await user.fetchUserData();
      setUserName(account.holder.name);
      setLoading(false);
    } catch (error) {
      navigate(Routes.ERROR_SCENE, {
        state: {
          title: error.message || 'Erro ao buscar informações do usuário',
          description: 'Por favor, tente novamente',
        },
      });
    }
  };

  useEffect(() => {
    if (id && id !== 'undefined') {
      creditProducts.setQrCodeId(id);
      initialize();
    } else {
      navigate(Routes.ERROR_SCENE, {
        state: {
          title: 'Erro ao resgatar o ID do QR Code',
        },
      });
    }
  }, []);

  return (
    <CreditSimulationIntro
      availableLimit={creditProducts.productLoanDetails.availableLimit}
      onSubmit={() => navigate(Routes.CREDIT_SIMULATION_VALUE)}
      loading={loading}
      userName={userName}
    />
  );
};

export default observer(CreditSimulationIntroContainer);
